export default "__VITE_ASSET__cc0a264c__"